export const sortTaskStatuses = (arr: TaskStatus[]) => {
  return arr.slice().sort((a, b) => {
    const aOrder = a.flow_order ?? 0
    const bOrder = b.flow_order ?? 0
    return aOrder - bOrder
  })
}
